import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async create(datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones('requisitos-financieros'), datos);
  },
  async findAll() {
    return await axiosIns.get(obtenerUrlAPIComisiones('requisitos-financieros'));
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`requisitos-financieros/${id}`));
  },
  async update(id, datos) {
    return await axiosIns.patch(obtenerUrlAPIComisiones(`requisitos-financieros/${id}`), datos);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIComisiones(`requisitos-financieros/${id}`));
  },
  async findByInstitucion(institucionId) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`requisitos-financieros/instituciones/${institucionId}`));
  },
};
